<template>
  <div class="overflow-auto">
    <ul class="nav nav-pills mb-2">
      <li class="nav-item">
        <a
            :class="'nav-link ' + (groupBy === 'category' ? 'active' : '')"
            href="#"
            @click="groupBy = 'category'">
          По категориям
        </a>
      </li>

      <li class="nav-item">
        <a
            :class="'nav-link ' + (groupBy === 'health' ? 'active' : '')"
            href="#"
            @click="groupBy = 'health'">
          По статусам здоровья
        </a>
      </li>
    </ul>

    <table
        v-if="groups.length > 0"
        class="table table-hover table-bordered"
        style="width:auto">
      <thead>
      <th>&nbsp;</th>
      <th><small>ед.</small></th>

      <th
          v-for="date in dates"
          :key="date"
          class="px-1 text-center">
        <small>{{ date }} </small>
      </th>
      </thead>

      <tbody
          v-for="group in groups"
          :key="group.groupId">
      <tr>
        <th :colspan="dates.length + 2">
          {{ group.groupName }}
        </th>
      </tr>
      <tr
          v-for="test in group.tests"
          :key="test.testId">
        <td width="400" style="width: 400px !important;" class="text-nowrap py-0">
          <div class="py-2">{{ test.testName }}</div>
        </td>
        <td width="40" style="width:40px !important;" class="text-nowrap py-0">
          <div class="py-2">{{ test.testMeasure }}</div>
        </td>

        <td
            v-for="date in dates"
            :key="group.groupId + '-' + test.testId + '-' + date"
            class="p-0">
          <div
              v-for="result in test.results"
              :key="group.groupId + '-' + test.testId + '-' + date + '-' + result.id">
            <div
                v-if="result.dateFormatted === date"
                :class="'py-2 text-center tests-result-status tests-result-status-' + result.status">
              {{ result.value }}
            </div>
          </div>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
  import formatDate from '../../../utils/formatDate';

  export default {
    name: 'ClientTestCalendar',

    props: ['client', 'results', 'healthElements'],

    data() {
      return {
        groupBy: 'category',
      };
    },

    computed: {
      dates() {
        const dates = [];

        for (const result of this.results) {
          const date = formatDate(new Date(result.date), 'd.m.y');

          if (dates.includes(date) === false) {
            dates.push(date);
          }
        }

        dates.sort((a, b) => {
          const [ad, am, ay] = a.split('.');
          const [bd, bm, by] = b.split('.');

          return parseInt(`${ay}${am}${ad}`) - parseInt(`${by}${bm}${bd}`);
        });

        return dates;
      },

      groups() {
        const groups = [];

        for (const result of this.results) {
          const dateFormatted = formatDate(new Date(result.date), 'd.m.y');
          const healthElement = this.healthElements.find(element => element.id === result.testHealthId);
          const healthName = typeof healthElement !== 'undefined' ? healthElement.name : '-';
          const healthSort = typeof healthElement !== 'undefined' ? healthElement.sort : 0;

          let group = groups.find(group => {
            if (this.groupBy === 'health') {
              return group.groupId === result.testHealthId;
            }

            return group.groupId === result.categoryId;
          });

          if (typeof group === 'undefined') {
            group = {
              groupId: this.groupBy === 'health' ? result.testHealthId : result.categoryId,
              groupName: this.groupBy === 'health' ? healthName : result.categoryName,
              groupSort: this.groupBy === 'health' ? healthSort : result.categorySort,
              tests: [],
            };

            groups.push(group);
          }

          let test = group.tests.find(test => {
            return test.testId === result.testId;
          });

          if (typeof test === 'undefined') {
            test = {
              testId: result.testId,
              testName: result.testName,
              testMeasure: result.testMeasure,
              testReference: result.testReference,
              results: [],
            };

            group.tests.push(test);
          }

          test.results.push(Object.assign({dateFormatted}, result));
        }

        groups.sort((a, b) => a.groupSort - b.groupSort);

        for (const group of groups) {
          group.tests.sort((a, b) => a.groupSort - b.groupSort);
        }

        return groups;
      },
    },
  };
</script>
